import React from "react";
import PageTitleCard from '../../components/common/PageTitleCard'
import { Link, useLocation } from 'react-router'

const ShippingPageLayout = ({
  children
}: {
  children: React.ReactNode
}) => {
  const location = useLocation();
  const { pathname } = location;
  const paths = pathname.split("/");
  const activePath = paths[paths.length-1];

  const activeTabClassName = "py-2 px-4 rounded-xl cursor-default bg-main-blue text-white font-semibold";
  const tabClassName = "bg-neutral-200 hover:bg-neutral-300/80 text-gray-500 cursor-pointer transition-all ease-in-out duration-300 py-2 px-4 rounded-xl"
  return (
    <div className='h-full relative'>
      <div className="bg-white p-4 rounded-xl overflow-hidden"> 
        <PageTitleCard title="Data Pengiriman" />
        <hr />
        <div className='mt-5'>
          <ul className='flex gap-4'>
            <li className={activePath === "shipping" ? activeTabClassName : tabClassName}>
              <Link to="/shipping">
                Daftar Kiriman
              </Link>
            </li>
            <li className={activePath === "create" ? activeTabClassName : tabClassName}>
              <Link to="/shipping/create">
                Data Entri
              </Link>
            </li>
            <li className={activePath === "shipment" ? activeTabClassName : tabClassName}>
              <Link to="/shipping/shipment">
                Kirim
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className='mt-5 mb-60'>
        {children}
      </div>
    </div>
  )
}

export default ShippingPageLayout;